/*
 * @Author: your name
 * @Date: 2021-09-08 13:35:56
 * @LastEditTime: 2021-09-08 13:40:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/utils/vue-error-handler.js
 */
import Vue from 'vue'
const errorHandler = (error, vm)=>{
  console.error('抛出全局异常')
  console.error(vm)
  console.error(error)
}
Vue.config.errorHandler = errorHandler
Vue.prototype.$throw = (error)=> errorHandler(error,this)
